import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "alert alert-success alert-dismissible fade show",
  style: {"z-index":"4000"},
  role: "alert"
}
const _hoisted_2 = { class: "d-flex flex-column align-items-start" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check-circle-fill" }, null, -1)
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "ps-8 text-sm" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "d-flex align-self-end mt-2 mx-n3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _hoisted_3,
        _createElementVNode("span", {
          class: "ps-3 font-bold",
          innerHTML: _ctx.title
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.texts, (text, index) => {
          return (_openBlock(), _createElementBlock("ul", {
            class: "m-0 mt-1 ps-3",
            key: index
          }, [
            _createElementVNode("li", { innerHTML: text }, null, 8, _hoisted_6)
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("a", {
          class: "alert-link text-sm font-semibold mx-3",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('dismiss')))
        }, "Dismiss")
      ])
    ])
  ]))
}